import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { message } from 'antd';
import moment from 'moment';
import reporteTrazabilidadService from '../../../service/logistica/reporteTrazabilidadService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                referencia: '',
                ...FILTER
            },

            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            referencia: '',
            ...FILTER
        };
        this.setState({ filter });
        this.handlePagination();
    };

    handleChange = async (property, value) => {

        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var filter = { ...this.state.filter };
        filter.anio = parseInt(moment(filter.fechaInicioStr, 'DD/MM/YYYY').format('YYYY'));

        var response = await reporteTrazabilidadService.excel(filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Trazabilidad de Productos.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true, filter: { ...this.state.filter, anio: parseInt(moment(this.state.filter.fechaInicioStr, 'DD/MM/YYYY').format('YYYY')) } });
        var response = await reporteTrazabilidadService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ventas por Producto.pdf");
    };



    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this.handlePagination();
        }
    };

    handlePagination = () => {
        var filter = { ...this.state.filter };
        filter.anio = parseInt(moment(filter.fechaInicioStr, 'DD/MM/YYYY').format('YYYY'));

        this._initPagination(filter, reporteTrazabilidadService.paginacion);

    }

    async componentDidMount() {
        //this._initPagination(this.state.filter, reporteTrazabilidadService.paginacion);

    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Trazabilidad de Productos por Serie"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    productos={this.state.productos}
                    tipoProductos={this.state.tipoProductos}
                    establecimientos={this.state.establecimientos}
                    marcas={this.state.marcas}
                    monedas={this.state.monedas}
                    proyectos={this.state.proyectos}
                    proveedores={this.state.proveedores}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    onExportExcel={this.handleExportExcel}
                //onExportPdf={this.handleExportPdf}
                //onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}